module.exports = __webpack_public_path__ + "static/assets/6fb602003b4d9e845e84f77129346396.svg";